import { Card, FormControl, FormGroup, Grid, Icon } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/miniCrm/contact";
import { mapActionsToProps as indastryAction } from "../../redux/miniCrm/indastry";
import DialogCampaign from "./../../components/CampaignDialog";
import { mapActionsToProps as CampaignAction } from "./../../redux/campaigns";
import { mapActionsToProps as stageAction } from "./../../redux/miniCrm/stage";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
});

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      dob: new Date(),
      openCampaign: false,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "title", numeric: true, disablePadding: false, label: "Danh xưng" },
    {
      id: "fullName",
      numeric: true,
      disablePadding: false,
      label: "Khách hàng",
    },
    { id: "gender", numeric: true, disablePadding: false, label: "Giới tính" },
    { id: "email", numeric: true, disablePadding: false, label: "Email" },
    { id: "tags", numeric: true, disablePadding: false, label: "Tags" },
    {
      id: "phoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại",
    },
    {
      id: "industry",
      numeric: true,
      disablePadding: false,
      label: "Nghề nghiệp",
    },
    {
      id: "organization",
      numeric: true,
      disablePadding: false,
      label: "Nơi làm việc",
    },
    { id: "address", numeric: true, disablePadding: false, label: "Địa chỉ" },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "firstName":
            case "email":
            case "gender":
            case "phoneNumber":
            case "jobTitle":
            case "organization":
            case "address":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListContacts({ where: where });
    this.props.getListContacts(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      },
      {
        include: [
          { relation: "industry", scope: { fields: { id: true, name: true } } },
          { relation: "state", scope: { fields: { id: true, name: true } } },
        ],
      }
    );
    this.props.getListStage();
    this.props.getListIndastry();
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalEdit: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    // this.setState({ modalEdit: true })
    this.history.push(
      `${process.env.REACT_APP_PATH}/contact-center/contact/edit-contact/${item.id}`
    );
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] =
      name !== "industryId" && name !== "gender" ? { like: value } : value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeBirthday = (date) => {
    this.setState({ dob: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleDelete = () => {
    this.props.deleteContact(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleCloseModal = () => {
    this.setState({ openCampaignConfig: false, openCampaign: false });
    this.props.openModalNotification();
  };

  handleOpenCampaign = () => {
    this.setState({ openCampaignConfig: true });
    this.props.closeModalCampaign();
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  render() {
    const { classes, listContact, coutContact, listIndastry, listStage } =
      this.props;
    const { id, name, note, providerId, filters, item, modalDelete, notes } =
      this.state;
    const listContactResult =
      typeof listContact === "object"
        ? Object.keys(listContact).map((key) => listContact[key])
        : listContact;
    const listIndastryResult =
      typeof listIndastry === "object"
        ? Object.keys(listIndastry).map((key) => listIndastry[key])
        : listIndastry;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên khách hàng"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.fullName
                            ? filters.where.fullName.like
                            : ""
                        }
                        name="fullName"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <SelectValidator
                        id="outlined-full-width"
                        margin="normal"
                        select
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                            shrink: true,
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Giới tính"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.gender}
                        name="gender">
                        <MenuItem>Tất cả</MenuItem>
                        <MenuItem key={"male"} value={"male"}>
                          Nam
                        </MenuItem>
                        <MenuItem key={"female"} value={"female"}>
                          Nữ
                        </MenuItem>
                      </SelectValidator>
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Email"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.email ? filters.where.email.like : ""
                        }
                        name="email"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Số điện thoại"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.phoneNumber
                            ? filters.where.phoneNumber.like
                            : ""
                        }
                        name="phoneNumber"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={24}>
                    <Grid item md={3}>
                      <SelectValidator
                        id="outlined-full-width"
                        margin="normal"
                        select
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                            shrink: true,
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Nghề nghiệp"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.industryId}
                        name="industryId">
                        <MenuItem>Tất cả</MenuItem>
                        {listIndastryResult
                          ? listIndastryResult.map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </SelectValidator>
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Nơi làm việc"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.organization
                            ? filters.where.organization.like
                            : ""
                        }
                        name="organization"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Địa chỉ"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.address
                            ? filters.where.address.like
                            : ""
                        }
                        name="address"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                      {this.state.openCampaign ? (
                        <Fab
                          className={classes.campaign}
                          color="primary"
                          variant="extended"
                          onClick={this.handleOpenCampaign}>
                          <Icon className={classes.campaignIcon}>input</Icon>
                          Phân bổ chiến dịch
                        </Fab>
                      ) : null}
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh bạ"
          items={listContactResult}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={() =>
                  this.history.push(
                    `${process.env.REACT_APP_PATH}/contact-center/contact/create-contact`
                  )
                }>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa khách hàng?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <DialogCampaign
          open={this.state.openModalCampaign && this.props.closeModalCampaign}
          onClose={this.handleCloseModal}
          // contactFileId={!!this.state.item ? this.state.item.id ? this.state.item.id : '' : ''}
          type="contact"
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

Contact.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listContact: state.contact.contacts,
  count: state.contact.count,
  listIndastry: state.indastry.indastries,
  listStage: state.stage.stages,
  closeModalCampaign: state.campaign.closeDialog,
  loading: state.contact.loading,
});
const Campaign = connect(null, CampaignAction)(Contact);
const Indastry = connect(null, indastryAction)(Campaign);
const Stage = connect(null, stageAction)(Indastry);
Contact = connect(mapStateToProps, mapActionsToProps)(Stage);

export default withStyles(styles)(Contact);
